import { downFile, dayTime, formatTimestamp } from '@/utils/utils';

export const search = {
  data() {
    return {
      formModel: {
        sn: '',
        officeId: [],
        taskId: [],
        deviceModel: [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()]
      },
      rules: {
        sn: [{ required: true, message: '请选择设备', trigger: 'change' }]
      },
      mulTime: {
        dateType: 'daterange',
        type: 'date'
      },
      formButton: [
        {
          text: '查询',
          event: () => {
            this.search();
          }
        },
        {
          text: '导出',
          code: '010721',
          loading: false,
          event: this.exportData
        }
      ],
      dateRangeText: '',
      searchHooks: new Map()
    };
  },
  methods: {
    changeDateRangeText() {
      const { rangeDateVal } = this.formModel;
      this.dateRangeText = `（ ${formatTimestamp(rangeDateVal[0])} 至 ${formatTimestamp(
        rangeDateVal[1]
      )}）`;
    },
    hisExport(op) {
      op.loading = true;
      downFile({
        url: '/devicedata/exportHisDetect',
        method: 'post',
        data: this.comParams
      }).finally(() => {
        op.loading = false;
      });
    },
    search() {
      [...this.searchHooks.values()].forEach(e => e.call(this));
    }
  },
  created() {
    this.initSearchHooks();
    this.search();
  }
};
